import ReducerConstants from "../../config/ReduxConstant";

const INITIAL_STATE = {};

export const klassProperties = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "SET_KLASS_PROPERTIES":
            return ({...state, ...action.payload}) || state;
        default:
            return state
    }
}